export const Copy16 = ({ className, onClick }: { className?: string; onClick?: () => void }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <g clip-path="url(#clip0_988_3227)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.97363 0.511719C10.4878 0.564101 10.9712 0.791545 11.3398 1.16016C11.7612 1.58148 11.9983 2.15319 12 2.74902V2.75488L11.9893 4H13.2188C14.4786 4 15.5 5.02135 15.5 6.28125V13.2188C15.5 14.4786 14.4786 15.5 13.2188 15.5H6.28125C5.02135 15.5 4 14.4786 4 13.2188V12H2.74902C2.15318 11.9983 1.58148 11.7612 1.16016 11.3398C0.738833 10.9185 0.501695 10.3468 0.5 9.75098V2.99805L0.512695 2.75195C0.570883 2.18055 0.824717 1.64403 1.23438 1.23438C1.7024 0.766347 2.33617 0.502082 2.99805 0.5H9.75098L9.97363 0.511719ZM6.28125 5C5.57364 5 5 5.57364 5 6.28125V13.2188C5 13.9264 5.57364 14.5 6.28125 14.5H13.2188C13.9264 14.5 14.5 13.9264 14.5 13.2188V6.28125C14.5 5.57364 13.9264 5 13.2188 5H6.28125ZM2.85352 1.50781C2.51006 1.54274 2.18764 1.69518 1.94141 1.94141C1.66008 2.22273 1.50118 2.6041 1.5 3.00195V9.74902L1.50684 9.87207C1.53596 10.1583 1.66201 10.4276 1.86719 10.6328C2.10157 10.8672 2.41953 10.9989 2.75098 11H4V6.28125C4 5.02135 5.02135 4 6.28125 4H10.9893L11 2.75098L10.9932 2.62793C10.964 2.34174 10.838 2.07237 10.6328 1.86719C10.4276 1.66201 10.1583 1.53596 9.87207 1.50684L9.74902 1.5H3.00195L2.85352 1.50781Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_988_3227">
          <rect
            width="16"
            height="16"
            fill="currentColor"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
